/* =============================================================================
   STUDIO ARCHIVE — transition.js
   Page shutter wipe — intercepts internal nav, reveals on load
   ============================================================================= */

(function () {
  var shutter = document.getElementById('page-shutter');
  if (!shutter) return;

  // Honour the global transitions toggle written by theme.liquid
  if (window.StudioArchive && window.StudioArchive.transitionsDisabled) {
    shutter.style.display = 'none';
    return;
  }

  // --- Reveal current page on load ---
  requestAnimationFrame(function () {
    shutter.classList.add('is-revealing');
    shutter.addEventListener('animationend', function () {
      shutter.classList.remove('is-revealing');
    }, { once: true });
  });

  // --- Intercept internal navigation ---
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;
    if (href.startsWith('#')) return;
    if (href.startsWith('mailto:') || href.startsWith('tel:')) return;
    if (link.target === '_blank' || link.hasAttribute('download')) return;
    if (link.classList.contains('no-transition')) return;

    var isInternal = href.startsWith('/') || href.startsWith(window.location.origin);
    if (!isInternal) return;

    e.preventDefault();
    shutter.classList.remove('is-revealing');
    shutter.classList.add('is-covering');

    shutter.addEventListener('animationend', function () {
      window.location.href = href;
    }, { once: true });
  });

  // --- Restore on back/forward (bfcache) ---
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      shutter.classList.remove('is-covering', 'is-revealing');
      shutter.style.transform = 'translateY(-100%)';
    }
  });
})();
